// Create-Video Page Entry Point
import '../../js/config.js';
import '../../js/initSideNav.js';
import '../../js/translations.js';
import '../../js/utils/TokenManager.js';
import { parseCreateVideoConfig } from '../../js/create/videoPage/parseCreateVideoConfig.js';
import { startCreateVideoPage } from '../../js/create/videoPage/startCreateVideoPage.js';

const config = parseCreateVideoConfig();
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => startCreateVideoPage(config));
} else {
  startCreateVideoPage(config);
}
